//pluginTranslations.js

import i18n from "../i18n";
import store from "../store";

export default {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    //var that = this;
    Vue.prototype.uniTranslation = function(code, cult) {
      var str = i18n.t(code, cult);
      if (store.getters["_authModule/bShowTranslationsId"] == true) {
        if (str != code) {
          return "[" + code + "] " + str;
        } else {
          return "### " + str;
        }
      } else {
        return str;
      }
    };

    Vue.prototype.uniToolTipTranslation = function(code, cult) {
      var str = i18n.t(code, cult);
      // Ipotizzo che Dove chiedo la cultura sto anche Chiedendo di visualizzare il tooltip in inglese!!!'
      if (store.getters["_authModule/bShowEnglishToolTip"] == false) {
        return "";
      }

      return str;
    };
  }
};
